import React, { useContext, useEffect, useState } from "react";
import Form from "react-bootstrap/Form";
import "./FilterJob.css";
import UserContext from "../../../component/ContextApi/UserContext";
import { URLS } from "../../../../Utils/App_urls";
import axios from "axios";
import { RiCornerUpRightDoubleFill, RiSearch2Fill } from "react-icons/ri";
import BackArrowIcon from "../../../../assets/filter-back-arrow.png";
import { IoSearch } from "react-icons/io5";
import { useLocation } from "react-router-dom";

export default function FilterJob({ isFilterShow, handleSetFilter }) {
  const { setAllAfterFilter } = useContext(UserContext);
  const [jobsForFilter, setJobsForFilter] = useState([]);
  const [jobTitle, setJobTitle] = useState("");
  const [skillInput, setSkillInput] = useState("");
  const [locations, setLocations] = useState("");
  const [isSearching, setIsSearching] = useState(false);
  const location = useLocation();

  const isLoggedIn = !!localStorage.getItem("userToken");

  const [filterJob, setFilterJob] = useState({
    sortByTime: "all",
    workExperience: "",
    preferenceWorkPlace: "",
    preferredShift: "",
    EmploymentType: "",
  });

  const handleSortByTimeChange = (e, type) => {
    const { id, value } = e.target;
    let newFilterJob = { ...filterJob };

    switch (type) {
      case "sortByTime":
        newFilterJob.sortByTime = id;
        getAllJobs("sortBy", id);
        break;
      case "workExp":
        newFilterJob.workExperience = value;
        getAllJobs("experience", value);
        break;
      case "workPlace":
        newFilterJob.preferenceWorkPlace = id;
        getAllJobs("workPlace", id);
        break;
      case "preferredShift":
        newFilterJob.preferredShift = id;
        getAllJobs("shift", id);
        break;
      case "employmentType":
        newFilterJob.EmploymentType = id;
        getAllJobs("deparmentType", id);
        break;
      default:
        break;
    }

    setFilterJob(newFilterJob);
  };

  const handleResetFilter = () => {
    const resetFilterJob = {
      sortByTime: "all",
      workExperience: "",
      preferenceWorkPlace: "",
      preferredShift: "",
      EmploymentType: "",
    };
    setFilterJob(resetFilterJob);
    getAllJobs();
  };

  const [filterOption, setFilterOption] = useState({
    workPlace: "",
    experience: "",
    sortBy: "",
    deparmentType: "",
    title: "",
    shift: "",
  });

  const getAllJobs = (type = "reset", option = "") => {
    const paramsOpt = {
      page: 1,
      limit: 10,
      ...filterOption,
    };

    if (type === "workPlace") {
      paramsOpt["workPlace"] = option;
    } else {
      paramsOpt["workPlace"] = filterJob?.preferenceWorkPlace;
    }

    if (type === "experience" && option) {
      paramsOpt["experience"] = option;
    } else {
      paramsOpt["experience"] = filterJob?.workExperience;
    }

    if (type === "sortBy" && option) {
      paramsOpt["sortBy"] = option;
    } else {
      paramsOpt["sortBy"] = filterJob?.sortByTime;
    }

    if (type === "deparmentType" && option) {
      paramsOpt["deparmentType"] = option;
    } else {
      paramsOpt["deparmentType"] = filterJob?.EmploymentType;
    }

    if (type === "title" && option) {
      paramsOpt["title"] = option;
    } else {
      paramsOpt["title"] = jobTitle;
    }
    if (type === "skills" && option) {
      paramsOpt["skills"] = option;
    } else {
      paramsOpt["skills"] = skillInput;
    }
    if (type === "jobLocations" && option) {
      paramsOpt["jobLocations"] = option;
    } else {
      paramsOpt["jobLocations"] = locations;
    }
    if (type === "shift" && option) {
      paramsOpt["shift"] = option;
    } else {
      paramsOpt["shift"] = filterJob?.preferredShift;
    }

    Object.keys(paramsOpt).forEach((key) => {
      if (!paramsOpt[key]) {
        delete paramsOpt[key];
      }
    });

    axios
      .get(`${URLS.getAllJob}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("userToken")}`,
        },
        params:
          type === "reset"
            ? {
                page: 1,
                limit: 10,
              }
            : paramsOpt,
      })
      .then((res) => {
        let jobs = res?.data?.result || [];
        console.log("Meri job without Filter", jobs);
        if (type === "sortBy" && option === "recent") {
          const today = new Date().toISOString().split("T")[0];
          jobs = jobs.filter((job) => {
            const jobDate = new Date(job?.createdAt)
              .toISOString()
              .split("T")[0];
            return jobDate === today;
          });
        }

        setJobsForFilter(jobs);
        setAllAfterFilter(jobs);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const handleFilterJobsByTitle = (e) => {
    const { value } = e.target;
    getAllJobs("title", value);
    setJobTitle(value);
  };

  const handleSearchBySkills = (e) => {
    const { value } = e.target;
    getAllJobs("skills", value);
    setSkillInput(value);
  };
  const handleSearchByLocation = (e) => {
    const { value } = e.target;
    getAllJobs("jobLocations", value);
    setLocations(value);
  };

  const handleSubmitForm = (e) => {
    e.preventDefault();
  };

  useEffect(() => {
    console.log("in useEffect")
    // if(location.search?.includes("location")){
    //   let location = location.search?.includes("location")?.split("=")[1] || '';
    //   getAllJobs("jobLocations", location);
    // } else if(location.search?.includes("category")){
    //   let title = location.search?.includes("category")?.split("=")[1] || '';
    //   getAllJobs("title", title);
    // } else if(location.search?.includes("industry")){
    //   let industryType = location.search?.includes("industry")?.split("=")[1] || '';
    //   getAllJobs("industryType", industryType);
    // }
  }, [location.search]);
  return (
    <>
      <div className="filter-job-main d-flex flex-column gap-3">
        <div className="filter-header d-flex align-items-center justify-content-between">
          <h1
            onClick={() => handleSetFilter(false)}
            className={isFilterShow ? "filter-head" : "filter-head-black"}
          >
            {isFilterShow && <img src={BackArrowIcon} alt="back-arrow" />}
            Filter
          </h1>
          <p onClick={handleResetFilter}>Reset</p>
        </div>
        <div className="cross-line-dividor" />

        {isLoggedIn && (
          <>
            <div className="job-search-header d-flex gap-1 mb-3 p-0">
              <Form
                onSubmit={handleSubmitForm}
                className="d-flex gap-1 justify-content-sm-between justify-content-center flex-wrap"
              >
                <div className="serch-job-input d-flex align-items-center justify-content-between">
                  <IoSearch fontSize={20} />
                  <Form.Control
                    placeholder="Job Title"
                    aria-label="Job Title"
                    value={jobTitle}
                    onChange={(e) => handleFilterJobsByTitle(e)}
                  />
                </div>
              </Form>
            </div>
            <div className="cross-line-dividor" />
          </>
        )}

        <div className="sort-container">
          <p>Sort By</p>
          {["all", "recent", "lastWeek", "lastMonth"].map((time) => (
            <span key={time}>
              <input
                type="radio"
                name="sort-by-time"
                id={time}
                value={time}
                checked={filterJob?.sortByTime === time}
                onChange={(e) => handleSortByTimeChange(e, "sortByTime")}
              />
              <label htmlFor={time}>
                {time === "recent"
                  ? "Today"
                  : time === "lastWeek"
                  ? "Last week"
                  : time === "lastMonth"
                  ? "Last 30 Days"
                  : "All"}
              </label>
            </span>
          ))}
        </div>
        <div className="cross-line-dividor" />
        <div className="work-experience-menu d-flex flex-column gap-2">
          <h1>Work Experience</h1>
          <Form.Select
            value={filterJob.workExperience || ""}
            onChange={(e) => handleSortByTimeChange(e, "workExp")}
          >
            <option value={""} disabled>
              Select Experience
            </option>
            <option value="Fresher">Fresher</option>
            <option value="1-2 years">1-2 years</option>
            <option value="2-3 years">2-3 years</option>
            <option value="3-5 years">3-5 years</option>
            <option value="5+ years">5 + years</option>
          </Form.Select>
        </div>
        <div className="cross-line-dividor" />
        <div className="sort-container">
          <p>Preferred Workplace</p>
          {["On-site", "Off-site", "Hybrid"].map((place) => (
            <span key={place}>
              <input
                type="radio"
                name="preferred-workplace"
                id={place}
                value={place}
                checked={filterJob?.preferenceWorkPlace === place}
                onChange={(e) => handleSortByTimeChange(e, "workPlace")}
              />
              <label htmlFor={place}>
                {place === "Off-site" ? "Work From Home" : place}
              </label>
            </span>
          ))}
        </div>
        <div className="cross-line-dividor" />
        <div className="sort-container">
          <p>Preferred Shift</p>
          {["Day Shift", "Night Shift"].map((shift) => (
            <span key={shift}>
              <input
                type="radio"
                name="Preferred-Shift"
                id={shift}
                value={shift}
                checked={filterJob.preferredShift === shift}
                onChange={(e) => handleSortByTimeChange(e, "preferredShift")}
              />
              <label htmlFor={shift}>{shift}</label>
            </span>
          ))}
        </div>
        <div className="cross-line-dividor" />
        <div className="sort-container">
          <p>Employenment Type</p>
          {["Full Time", "Part Time", "contract"].map((type) => (
            <span key={type}>
              <input
                type="radio"
                name="Employenment-Type"
                id={type}
                value={type}
                checked={filterJob.EmploymentType === type}
                onChange={(e) => handleSortByTimeChange(e, "employmentType")}
              />
              <label htmlFor={type}>{type}</label>
            </span>
          ))}
        </div>
        <div className="cross-line-dividor" />
        <div className="sort-container">
          <p>Skills</p>
          <span className="location-input">
            <input
              className="input-skills"
              value={skillInput}
              onChange={(e) => handleSearchBySkills(e)}
              type="text"
              name="skill"
              placeholder="search by skills"
            />
          </span>
        </div>
        <div className="cross-line-dividor" />
        <div className="sort-container">
          <p>Location</p>
          <span className="location-input">
            <input
              className="input-locations"
              value={locations}
              onChange={(e) => handleSearchByLocation(e)}
              type="text"
              name="location"
              placeholder="search by location"
            />
          </span>
        </div>
      </div>
    </>
  );
}
